import { createApi } from '@reduxjs/toolkit/query/react';

import baseQuery from 'src/utils/baseQuery';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery,
  endpoints: (builder) => ({
    getCallDetails: builder.mutation({
      query: (requestApi) => ({
        url: 'call/dashboard',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getMessageDetails: builder.mutation({
      query: (requestApi: any) => ({
        url: 'message/dashboard',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getTicketCount: builder.mutation({
      query: (requestApi: any) => ({
        url: 'ticket/dashboard',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getCallGraphDetail: builder.mutation({
      query: (requestApi: any) => ({
        url: 'call/dashboard',
        method: 'POST',
        body: { ...requestApi, isGraph: true },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getConversationDetail: builder.mutation({
      query: (requestApi: any) => ({
        url: 'conversation/countConversation',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getAccountCount: builder.mutation({
      query: (requestApi: any) => ({
        url: 'company/dashboard',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getContactCount: builder.mutation({
      query: (requestApi: any) => ({
        url: 'contact/dashboard',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getUserCount: builder.mutation({
      query: (requestApi: any) => ({
        url: 'user/dashboard',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getChannelCount: builder.mutation({
      query: (requestApi: any) => ({
        url: 'channel/dashboard',
        method: 'POST',
        body: requestApi,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useGetCallDetailsMutation,
  useGetMessageDetailsMutation,
  useGetTicketCountMutation,
  useGetCallGraphDetailMutation,
  useGetConversationDetailMutation,
  useGetAccountCountMutation,
  useGetContactCountMutation,
  useGetUserCountMutation,
  useGetChannelCountMutation,
} = dashboardApi;
